<template>
  <VBtn class="link" flat :disabled="isLoading || isDisabled" @click="showLoginLink"
    >Login link</VBtn
  >
</template>

<script setup lang="ts">
  // Types
  import type { ManagerUserModel } from '~/modules/manager/models/user';
  import type { TLoginLink } from '~/modules/manager/company/users/types';

  // Composables
  import { useNotifyResource } from '~/misc/resource/composables/use-notify-resource';

  // Components
  import VBtn from '~/misc/v-btn';

  const LoginLinkModal = defineAsyncComponent(
    () => import('~/modules/manager/company/users/login-link/modal/LoginLinkModal.vue')
  );

  const props = defineProps({
    userId: {
      type: Number,
      required: true,
    },
    model: {
      type: Object as PropType<ManagerUserModel>,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  });

  const isLoading: Ref<boolean> = ref<boolean>(false);
  const { notifyFailure } = useNotifyResource();
  const { show: showModal } = useModal();

  const showLoginLink = () => {
    isLoading.value = true;

    props.model
      .loginLink(props.userId)
      .then((response: TLoginLink) => {
        showModal(LoginLinkModal, { link: response.link });
      })
      .catch((e) => {
        notifyFailure(e?.response?.data?.message || undefined);
      })
      .finally(() => {
        isLoading.value = false;
      });
  };
</script>
